<template>
	<div class="app">
		<RouterView v-if="userStore.loaded" />
		<div class="app__loader" v-else></div>
		<Alerts />
	</div>
</template>
<script setup lang="ts">
import "@/assets/scss/normalize.scss";
import "@/assets/scss/vars.scss";
import "./App.scss";
import {useUserStore} from "@/stores/userStore";
import {onBeforeUnmount, onMounted} from "vue";
import {useNotificationsStore} from "@/stores/notificationsStore";
import Alerts from "@/components/Alerts/Alerts.vue";

let userStore = useUserStore();
let notificationsStore = useNotificationsStore();

onMounted(() => {
	userStore.startUpdating();
	notificationsStore.startUpdating();
});

onBeforeUnmount(() => {
	userStore.stopUpdating();
	notificationsStore.stopUpdating();
});

</script>